module.exports = __webpack_public_path__ + "static/media/S34.44e99c92.png";